module.exports = __webpack_public_path__ + "static/img/2_03.e35b959.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/03/2_03.jpg
// module id = uZ4R
// module chunks = 1